import { useParams } from "react-router-dom";
import { useEffect, useState } from "react";

function gerarSlug(nome) {
  return nome
    .toLowerCase()
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "")
    .replace(/\s+/g, "-");
}

function Produto() {
  const { slug } = useParams();

  const [produto, setProduto] = useState(null);

  useEffect(() => {
    async function carregar() {
      const response = await fetch(
        "https://raw.githubusercontent.com/accium-hub/accium-catalogo/main/catalogo/produtos.json",
      );

      const data = await response.json();

      const encontrado = data.find((p) => gerarSlug(p.nome) === slug);

      setProduto(encontrado);
    }

    carregar();
  }, [slug]);

  if (!produto) return <p style={{ padding: "40px" }}>Carregando...</p>;

  const mensagem = `Olá! Tenho interesse no produto: ${produto.nome}`;
  const whatsapp = `https://wa.me/554999140597?text=${encodeURIComponent(mensagem)}`;

  return (
    <section style={{ padding: "80px 20px", textAlign: "center" }}>
      <h1 style={{ color: "#f67f28", marginBottom: "20px" }}>{produto.nome}</h1>

      <img
        src={produto.imagem}
        alt={produto.nome}
        style={{
          width: "100%",
          maxWidth: "400px",
          height: "300px",
          objectFit: "contain",
          marginBottom: "20px",
        }}
      />

      <p style={{ marginBottom: "30px" }}>{produto.descricao}</p>

      <a href={whatsapp} target="_blank" rel="noreferrer" className="btn">
        Solicitar orçamento
      </a>
    </section>
  );
}

export default Produto;
